// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__25a_G","boxTitle":"Qualiphy_boxTitle__1s5_b","box":"Qualiphy_box__1vKta","toggleWrap":"Qualiphy_toggleWrap__32ygD"};